// extracted by mini-css-extract-plugin
export default {"content":"style_content__d0QbD","itemName":"style_itemName__hg9ps"};